<template>
  <div class="attendancce-punch">
    <div class="pb16">收支账</div>
    <div class="mains-content">
      <div class="flex-row">
        <div v-for="(item,index) in shopListMenu" :key="index" @click="onClick(item)" class="attendancce-list" v-perm="{key:'shopBill', value: item.auth}">
          <img :src="item.icon" alt=""> <span class="ml10 fs16 fb">{{item.name}}</span>
        </div>
      </div>
    </div>
    <store-account ref="accountForm"></store-account>
  </div>
</template>

<script>
import storeAccount from './storeAccount.vue';
export default {
  data() {
    return {
      shopListMenu: [
        // {name: '门店收支账', url: '', icon: require("../../../assets/images/new/askForLeave.png"), auth: 'shopBill:shopDetail'},
        {name: '门店收支明细', url: '', icon: require("../../../assets/images/new/askForLeave.png"), auth: 'shopBill:shopBilldetail'},
        {name: '门店应发明细', url: '/dataList/shopBill/shopGrantDetail', icon: require("../../../assets/images/new/abnormalAttendance.png"), auth: 'shopBill:shopDetail'},
        {name: '店员应发明细', url: '/dataList/shopBill/staffGrantDetail', icon: require("../../../assets/images/new/departure.png"), auth: 'shopBill:staffDetail'},
      ],
      list: [],
      userInfo: {
        shopBizConfig: {}
      }
    };
  },
  components: {storeAccount},
  created() {
    this.userInfo = this.$store.getters.ShopInfo;
    // this.list = [];
    // if (this.userInfo.superManage) {
    //   this.list = this.shopListMenu;
    // } else {
    //   this.list = this.staffListMenu;
    // }
  },
  mounted() {},
  methods: {
    onClick (item) {
      if (item.url) {
        this.$router.push(item.url);
      } else {
        this.$refs.accountForm.$emit("set", true)
      }
      
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../../assets/css/edit.less";
.attendancce-punch {
  position: relative;
  padding: 16px 16px 0;
  .attendancce-list {
    width: 200px;
    height: 100px;
    padding-left: 20px;
    display: flex;
    align-items: center;
    margin-right: 20px;
    cursor: pointer;
    border: 1px solid #efefef;
    border-radius: 10px;
  }
}
.mains-content {
  height: calc(100vh - 160px);
  background-color: #fff;
  border-radius: 10px;
  padding: 16px;
}
.item_title {
  font-size: 18px;
  font-weight: bold;
  color: #111;
  margin-bottom: 24px;
}
</style>